import { __classPrivateFieldGet } from '../../node_modules/tslib/tslib.es6.js';
import { SDKResource } from '../../client/client.js';

// AUTOGENERATED -- DO NOT EDIT
var _Erx_instances, _Erx_baseUrlThunk;
class Erx extends SDKResource {
    constructor(config) {
        super(config);
        _Erx_instances.add(this);
    }
    /**
     * Search for allergens.
     */
    searchAllergens(params, request) {
        return this.request('/allergen', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Search for medications.
     */
    searchMedications(params, request) {
        return this.request('/medication', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Checks for drug-allergy interactions for a patient. This endpoint requires the patient's allergies to be synced with the upstream eRx provider.
     */
    checkAllergyInteractions(params, request) {
        return this.request('/patient/{patientId}/interactions/allergy', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Checks for drug-drug interactions for a patient. This endpoint requires the patient's medications to be synced with the upstream eRx provider.
     */
    checkMedicationInteractions(params, request) {
        return this.request('/patient/{patientId}/interactions/medication', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Checks for drug-allergy and drug-drug interactions with a specific drug for a patient. This endpoint requires the patient's allergies and medications to be synced with the upstream eRx provider.
     */
    checkPrecheckInteractions(params, request) {
        return this.request('/patient/{patientId}/interactions/precheck/{drugId}', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Cancel prescription for patient.
     */
    cancelPrescription(params, request) {
        return this.request('/patient/{patientId}/prescriptions/{medicationRequestId}', 'delete', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Syncs demographic, allergy, and medication data for a patient with the upstream eRx provider.
     */
    syncPatient(params, request) {
        return this.request('/patient/{patientId}/sync', 'post', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Create an SSO link for a practitioner. This link can be used to log in to the eRx service as the specified practitioner.
     */
    connectPractitioner(params, request) {
        return this.request('/practitioner/connect', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Check eRx enrollment for a practitioner.
     */
    checkPractitionerEnrollment(params, request) {
        return this.request('/practitioner/{practitionerId}', 'get', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Enroll a practitioner in the eRx service.
     */
    enrollPractitioner(params, request) {
        return this.request('/practitioner/{practitionerId}', 'post', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
    /**
     * Unenroll a practitioner from the eRx service.
     */
    unenrollPractitioner(params, request) {
        return this.request('/practitioner/{practitionerId}', 'delete', __classPrivateFieldGet(this, _Erx_instances, "m", _Erx_baseUrlThunk).bind(this))(params, request);
    }
}
_Erx_instances = new WeakSet(), _Erx_baseUrlThunk = function _Erx_baseUrlThunk() {
    var _a, _b;
    return (_b = (_a = this.config.services) === null || _a === void 0 ? void 0 : _a['erxApiUrl']) !== null && _b !== void 0 ? _b : 'https://erx-api.zapehr.com/v3';
};

export { Erx };
//# sourceMappingURL=erx.js.map
